import { useNavigate } from "react-router-dom";
import "./RefundShared.css";

const Refund4 = () => {
    const navigate = useNavigate();

    const relatedArticles = [
        {
            title: "What is your refund policy?",
            description: "Learn about our refund policy and how to request a refund for your purchase.",
            link: "/what-is-your-refund-policy?"
        },
        {
            title: "What payment methods do you accept?",
            description: "View all the payment methods we accept for your convenience.",
            link: "/what-payment-methods-do-you-accept?"
        },
        {
            title: "How long does it take to process a refund?",
            description: "Understand the timeline for refund processing and when to expect your money back.",
            link: "/how-long-does-it-take-to-process-a-refund?"
        }
    ];

    return (
        <div className="rf-container">
            <header className="rf-header">
                <div className="rf-container-1200">
                    {/* <div className="rf-header-content">
                        <button 
                            className="rf-back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft /> Back
                        </button>
                        <div className="rf-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="rf-top-bar">
                            <a href="/submitrequest" className="rf-submit-btn">
                                <FaQuestionCircle className="btn-icon" /> Submit a request
                            </a>
                        </div>
                    </div> */}
                </div>
            </header>
            
            <main className="rf-main-content">
                <div className="rf-container-1200">
                    <nav className="rf-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li><a href="/refund">Refund and Pricing</a></li>
                            <li>Plan Changes</li>
                        </ol>
                    </nav>

                    <article className="rf-article">
                        <header className="rf-article-header">
                            <h1 className="rf-article-title">Can I upgrade or change my service plan after payment?</h1>
                            <div className="rf-article-meta">
                                <span>Posted by BooksComply Team</span>
                                <span>•</span>
                                <span>Last updated August 2025</span>
                            </div>
                        </header>
                        
                        <div className="rf-article-content">
                            <p>
                                Yes, you can upgrade or modify your service plan. In case of an upgrade, you'll only need to pay the difference. For downgrades or changes, contact our support team for assistance.
                            </p>
                            
                            {/* <div className="rf-plan-options">
                                {planOptions.map((option, index) => (
                                    <div key={index} className="rf-plan-option">
                                        <div className="rf-plan-content">
                                            <h3>{option.title}</h3>
                                            <p className="rf-plan-description">{option.description}</p>
                                            <ul className="rf-plan-process">
                                                {option.process.map((step, stepIndex) => (
                                                    <li key={stepIndex}>
                                                        <FaArrowRight className="rf-process-arrow" />
                                                        <span>{step}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                            <a 
                                                href={option.buttonLink} 
                                                className="rf-plan-button"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate(option.buttonLink);
                                                }}
                                            >
                                                {option.buttonText}
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                             */}
                            {/* <div className="rf-note">
                                <h4>Important Notes About Plan Changes:</h4>
                                <ul>
                                    <li>Upgrades take effect immediately, and you'll be billed the prorated difference</li>
                                    <li>Downgrades take effect at the end of your current billing cycle</li>
                                    <li>Annual plans offer significant savings compared to monthly billing</li>
                                    <li>No refunds for downgraded plans during the current billing period</li>
                                </ul>
                            </div> */}
                        </div>
                    </article>
                    
                    {/* <div className="rf-helpful-section">
                        <h3 className="rf-helpful-title">Was this article helpful?</h3>
                        <div className="rf-helpful-buttons">
                            <button className="rf-helpful-btn positive">
                                <FaCheckCircle /> Yes, it was helpful
                            </button>
                            <button className="rf-helpful-btn negative">
                                <FaTimesCircle /> No, I need more help
                            </button>
                        </div>
                    </div> */}
                    
                    <div className="rf-related-articles">
                        <h2 className="rf-related-title">Related Articles</h2>
                        <div className="rf-related-grid">
                            {relatedArticles.map((article, index) => (
                                <a 
                                    key={index} 
                                    href={article.link} 
                                    className="rf-related-card"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(article.link);
                                    }}
                                >
                                    <h3>{article.title}</h3>
                                    <p>{article.description}</p>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Refund4;